
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.11 9L8.18.766h.758L3.304 8.43h2.507c.985 0 1.685-.162 2.102-.485.401-.312.711-.713.93-1.203h.18c-.011.23-.107.633-.29 1.211-.171.547-.268.927-.289 1.14A21.863 21.863 0 006.523 9H2.11zM7.452.766L1.398 9H.633l5.656-7.664H3.555c-.854 0-1.459.096-1.813.289-.36.198-.633.586-.82 1.164h-.18c.005-.245.05-.656.133-1.234.042-.282.063-.48.063-.594L.921.67c.526.063 1.24.095 2.14.095h4.391z","fill":"currentColor"}})])
          )
        }
      }
    